import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group',
  },
})
export default styleOverride
